import AirDna from '../AirDna'
import CashOut from '../CashOut'
import { useEffect } from 'react'
import ShareCta from '../ShareCta'
import classnames from 'classnames'
import { Mortgages } from '../Mortgages'
import NoLoansPanel from '../NoLoansPanel'
import HomeInsurance from '../HomeInsurance'
import PurchasingPower from '../PurchasingPower'
import { Dashboard } from '../../shared/Dashboard'
import { RootState } from '../../../types/rootState'
import ImportantNow from '../../shared/ImportantNow'
import { PmiEstimatedModule } from '../PmiEstimated'
import { useDispatch, useSelector } from 'react-redux'
import { EstimatedValueWithContext } from '../../shared/EstimatedValue'
import InterestSection from '../../shared/InterestSection'
import ReverseMortgagesModule from '../ReverseMortgagesModule'
import { selectHomeUuid } from '../../../store/selectors/home'
import { fetchShowPmiModules } from '../../../store/slices/pmi'
import { IDLE, LoadingStatus } from '../../../types/loadingStatus'
import { ProvidedPmiModule } from '../PmiProvided/ProvidedPmiModule'
import { selectClientFetchId } from '../../../store/selectors/client'

import styles from './HomeownerDashboard.module.scss'

interface HomeownerDashboardProps {
  subdue?: () => void
  loanFocus?: boolean
  openLoans?: () => void
  closeLoans?: () => void
  delayedRender?: boolean
  disableAnimate?: boolean
}

const HomeownerDashboard = ({
  subdue,
  loanFocus,
  openLoans,
  closeLoans,
  delayedRender,
  disableAnimate,
}: HomeownerDashboardProps) => {
  const dispatch = useDispatch()
  const homeUuid = useSelector(selectHomeUuid)
  const clientId = useSelector(selectClientFetchId)
  const fetchShowPmiModulesStatus = useSelector<RootState, LoadingStatus>(
    state => state.pmi.fetchShowPmiModulesStatus
  )

  useEffect(() => {
    if (clientId && homeUuid && fetchShowPmiModulesStatus === IDLE) {
      dispatch(fetchShowPmiModules({ clientId, homeUuid }))
    }
  }, [dispatch, clientId, homeUuid, fetchShowPmiModulesStatus])

  return (
    <div
      className={classnames(
        styles.stage,
        !delayedRender && styles.loading,
        disableAnimate && styles.disableAnimate,
        loanFocus && styles.loanFocus,
        subdue && styles.subdue
      )}
    >
      <Dashboard
        data-qa='HomeownersDashboardLeft'
        className={classnames(styles.left, styles.dashboard)}
        onClick={openLoans}
        onFocus={openLoans}
      >
        <Mortgages onClickOutside={closeLoans} />
      </Dashboard>
      <Dashboard
        data-qa='HomeownersDashboardRight'
        className={classnames(styles.right, styles.dashboard)}
        onClick={closeLoans}
        onFocus={closeLoans}
      >
        <EstimatedValueWithContext />
        <NoLoansPanel />
        <ImportantNow />
        <PmiEstimatedModule />
        <ProvidedPmiModule />
        <ReverseMortgagesModule />
        <InterestSection withCurrentHomeData />
        <PurchasingPower />
        <CashOut />
        <HomeInsurance />
        <AirDna />
        <ShareCta />
      </Dashboard>
    </div>
  )
}

export default HomeownerDashboard
